export interface IReceptionDayData {
    from: string,
    until: string;
}

export default class ReceptionDayData {
    public from: string;
    public until: string;

    constructor(data: IReceptionDayData) {
        this.from = data.from;
        this.until = data.until;
    }

    toDTO(): IReceptionDayData {
      return {
        from: this.from,
        until: this.until
      };
    }

    static fromDTO(dto: IReceptionDayData): ReceptionDayData {
      return new ReceptionDayData(dto);
    }
}
